<template lang="html">
  <div class="group-select">
    <ul class="list-group d-block d-sm-flex">
      <template v-for="(item, index) in items">
        <li
          :class="['category-tree','pl-3', 'py-3', 'py-sm-1', `${index === (items.length - 1) ? 'last' : ''}`]"
          :selected="selectedId === item.id"
          :key="'gsd-' + index"
          @click="handleClick(item.id)">
          <template v-for="(category,level) in item.path_from_root">{{makeCategoryLevel(category.name, level)+'\n'}}</template>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: Array
  },

  data: () => ({
    selectedId: null
  }),

  methods: {
    handleClick (id) {
      this.selectedId = id
      this.$emit('selected', id)
    },

    makeCategoryLevel (categoryName, level) {
      if (level > 0) categoryName = '└ ' + categoryName
      for (let i = 1; i < level; i++) {
        categoryName = '   ' + categoryName
      }
      return categoryName
    }
  },

  watch: {
    items () {
      this.selectedId = null
    }
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .group-select {
    & ul {
      border: solid 1px $gray-200;
      max-height: 45vh;
      overflow-y: auto;
      list-style: none;

      & li {
        border-bottom: 1px solid #eee;
        &.last {
          border-bottom: none;
        }
      }

      & li:hover {
        background-color: $primary;
        cursor: pointer;
        color: $white;
      }

      & li[selected] {
        background-color: $secondary;
        color: $white;
      }
    }
  }

  .category-tree {
    text-align: left;
    white-space: pre;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/CategoryGroupSelect.vue